import * as React from "react";
import { AnalyticsTrigger } from "../../helpers/analytics/analytics-trigger/analytics-trigger.mjs";
import { PropsChecker } from "../../helpers/props-checker/props-checker.mjs";
const AccordionContext = React.createContext({
  openItems: [],
  setOpenItems: (
    /* istanbul ignore next */
    () => null
  )
});
const Accordion = (props) => {
  const getContent = () => {
    if (props.disableAnalyticsTrigger) {
      return /* @__PURE__ */ React.createElement(AccordionInner, { ...props });
    }
    return /* @__PURE__ */ React.createElement(
      AnalyticsTrigger,
      {
        trigger: [
          {
            callback: "onOpen",
            id: ([id]) => {
              return "Accordion - Open - ".concat(id);
            },
            elementId: ([id]) => {
              return "".concat(id);
            },
            elementType: "accordion",
            interactionType: "open"
          },
          {
            callback: "onClose",
            id: ([id]) => {
              return "Accordion - Close - ".concat(id);
            },
            elementId: ([id]) => {
              return "".concat(id);
            },
            elementType: "accordion",
            interactionType: "close"
          }
        ]
      },
      /* @__PURE__ */ React.createElement(AccordionInner, { ...props })
    );
  };
  return /* @__PURE__ */ React.createElement(PropsChecker, { componentProps: props, componentName: "Accordion", defaultValueName: "defaultOpenItem", valueName: "openItem", onChangeNames: "onToggle" }, getContent());
};
const _AccordionInner = class _AccordionInner extends React.Component {
  constructor(props) {
    super(props);
    this.setOpenItems = (id, isOpen) => {
      const openItems = this.getNewOpenItems(id, isOpen);
      if (!this.isControlled) {
        this.setState({ openItems });
      }
      if (this.props.onToggle) {
        this.props.onToggle(openItems);
      }
      if (isOpen && this.props.onOpen) {
        this.props.onOpen(id);
      } else if (!isOpen && this.props.onClose) {
        this.props.onClose(id);
      }
    };
    this.state = {
      openItems: _AccordionInner.getOpenItems(props.defaultOpenItem)
    };
  }
  static getOpenItems(items) {
    return items != null ? items : [];
  }
  get isControlled() {
    return typeof this.props.openItem !== "undefined";
  }
  get openItems() {
    return this.isControlled ? _AccordionInner.getOpenItems(this.props.openItem) : this.state.openItems;
  }
  BEM() {
    const classArray = ["accordion"];
    if (this.props.size) {
      classArray.push("accordion--" + this.props.size);
    }
    if (this.props.bordered) {
      classArray.push("accordion--bordered");
    }
    if (this.props.fullWidth) {
      classArray.push("accordion--full-width");
    }
    if (this.props.type) {
      classArray.push("accordion--type-".concat(this.props.type));
    }
    if (this.props.className) {
      classArray.push(this.props.className);
    }
    return classArray.join(" ");
  }
  getNewOpenItems(id, isOpen) {
    const openItems = this.openItems;
    if (!isOpen) {
      return openItems.filter((i) => i !== id);
    }
    return [...openItems, id];
  }
  get accordionContextValue() {
    var _a;
    return {
      openItems: this.openItems,
      setOpenItems: this.setOpenItems,
      headingLevel: (_a = this.props.headingLevel) != null ? _a : 2
    };
  }
  render() {
    const {
      onToggle,
      defaultOpenItem,
      openItem,
      onOpen,
      onClose,
      size,
      children,
      className,
      bordered,
      disableAnalyticsTrigger,
      headingLevel,
      fullWidth,
      ...rest
    } = this.props;
    return /* @__PURE__ */ React.createElement(AccordionContext.Provider, { value: this.accordionContextValue }, /* @__PURE__ */ React.createElement("div", { className: this.BEM(), "data-theme": this.props.theme, ...rest }, children));
  }
};
_AccordionInner.defaultProps = {
  bordered: true
};
let AccordionInner = _AccordionInner;
export {
  Accordion,
  AccordionContext
};
